/**
 * Created by mukund on 6/10/15.
 */
'use strict';

angular.module('mediacloudApp')
    .controller('PlaybackController', function ($scope, $http, $rootScope, $state, $window, $timeout, Principal, CollectionService, AssetService, BaseFileService, Auth, Tenant, DownloadableMedia, atmosphereService) {
        Principal.identity().then(function(account) {

            $scope.isAuthenticated = Principal.isAuthenticated;
            $scope.hideHeaderAndFooter = $rootScope.hideHeaderAndFooter;

            Tenant.info().then(function(tenant) {

                $scope.tenant = tenant;

                if (self === top && $window.location.hash.indexOf("#/lms/playback/") === 0) {

                    if ($scope.isAuthenticated()) {
                        Auth.logout();
                    }

                    $rootScope.previousStateName = undefined;

                    $rootScope.previousStateParams = undefined;

                    var managerUrl = $scope.tenant.managerUrl;

                    // logout of MediaManager and redirect to PPnP
                    if (managerUrl) {
                        $http.get($scope.tenant.managerUrl + '/j_acegi_logout', {withCredentials: true});
                        $window.location.href = managerUrl.substring(0, managerUrl.lastIndexOf('/'));
                    }

                } else {

                    $scope.account = account;
                    $scope.userFullName = "Anonymous User";
                    $scope.userName = "anonymousUser";

                    //Atmosphere set up for caption complete notification
                    var atmosphereSetup = function() {
                        console.log($scope.asset.createdBy);
                        var request = {
                            url: './notification/'+$scope.asset.createdBy,
                            contentType: 'application/json',
                            logLevel: 'debug',
                            transport: 'websocket',
                            fallbackTransport: 'streaming',
                            trackMessageLength: true,
                            reconnectInterval: 5000,
                            enableXDR: true,
                            timeout: 300000,
                            shared: true
                        };

                        request.onOpen = function(response) {
                            console.log('Atmosphere connected using ' + response.transport);
                        };

                        request.onMessage = function(response){
                            try{

                                var message = JSON.parse(response.responseBody);

                                if(message.messageType === 'caption'){
                                    if(message.responseType === 'success'){
                                        $scope.captionVar = "Closed Captions Available";
                                        $scope.asset.transcriptAvailable = true;
                                    }else if(message.responseType === 'failure'){
                                        $scope.captionVar = "Captioning Failed";
                                    }
                                }
                            }catch(err) {
                                console.log(err.message);
                            }
                        };

                        request.onClientTimeout = function(response){
                            setTimeout(function(){
                                atmosphereService.subscribe(request);
                            }, request.reconnectInterval);
                        };

                        atmosphereService.subscribe(request);
                    };

                    /*
                     Parse comments for hh:mm:ss or mm:ss timestamps and convert these timestamps into links which let you seek to that point in the audio/video
                     */
                    var parseComments = function (comments) {
                        // This is the regex for recognizing the hh:mm:ss or mm:ss pattern
                        var timeRegex = /([012]?\d?:?[0-5]?\d:[0-5]?\d)/;
                        // Loop over each comment and parse it so that timestamps are converted into links
                        comments.forEach(function (comment) {
                            var commentText = comment.commentText,
                                parts = commentText.split(timeRegex),
                                newCommentText = "";

                            for (var i = 0; i < parts.length; i++) {
                                if (/^[012]?\d?:?[0-5]?\d:[0-5]?\d$/.test(parts[i])) {
                                    newCommentText = newCommentText.concat("<a ng-click=\"jumpPlaybackTo('" + parts[i] + "')\">" + parts[i] + "</a>");
                                } else {
                                    newCommentText = newCommentText.concat(parts[i]);
                                }
                            }
                            comment.commentText = newCommentText;

                        });
                        return comments;
                    };

                    if($scope.isAuthenticated()) {
                        $scope.userName = $scope.account.login;
                        if ($scope.account.firstName || $scope.account.lastName) {
                            $scope.userFullName = $scope.account.firstName ? $scope.account.firstName : "";
                            $scope.userFullName += $scope.account.lastName ? " " + $scope.account.lastName : $scope.account.lastName;
                        } else {
                            $scope.userFullName = $scope.userName;
                        }
                    }

                    // Get the collectionId and assetId for the asset from the params
                    var collectionId = $state.params.collectionId,
                        assetId = $state.params.assetId,
                        collectionType = $scope.collectionType = $state.params.collectionType;

                    CollectionService.GetCollection.get({
                        cid: collectionId,
                        type: collectionType.toUpperCase()
                    }, function (collection) {
                        // Gets the collection
                        $scope.collection = collection;

                        // The parentID for the given asset is the cid for the current collection
                        var parentId = collection.cid;

                        if($rootScope.previousStateName && ["course", "channel", "protected", "lmscourse"].indexOf($rootScope.previousStateName.toLowerCase()) > -1){
                            var previousCollectionId = $rootScope.previousStateParams.collectionId;
                            // The collection in which the asset resides must be a linked collection, if this is satisfied
                            if(parentId != previousCollectionId) {
                                parentId = previousCollectionId;
                            }
                        }

                        CollectionService.GetCollection.get({
                            cid: parentId,
                            type: collectionType.toUpperCase()
                        }, function (parent) {
                            $scope.parent = parent;
                        });

                        $scope.$watch('parent', function(){
                            if($scope.parent){
                                // Get a few assets from the same parent collection to display in the sidebar
                                AssetService.GetAllAssets.get({cid: $scope.parent.cid}, function (assetList) {
                                    $scope.assets = assetList.assets;
                                });
                            }
                        });

                    });

                    // The maximum number of characters a comment can have
                    $scope.maxCommentLength = 255;

                    // For comments pagination
                    $scope.commentsPerPage = 5;
                    $scope.currentPage = 0;

                    //send to watson button or not
                    $scope.sentForCaptioning = false;
                    $scope.tickedForCaptioning = false;

                    //show send to watson button
                    $scope.showWatsonButton = false;

                    // Get the asset to be displayed
                    var getAsset = function () {
                        AssetService.GetAsset.get({cid: collectionId, aid: assetId}, function (asset) {
                            $scope.asset = asset;
                            if (asset.type === 'Video' || asset.type === 'Audio') {
                                $scope.mediaType = 'av';
                                if($scope.isAuthenticated()){
                                    if($scope.account.allowCaptionService
                                        && $scope.tenant.captioningServiceList.length
                                        && ($scope.tenant.captioningServiceList.indexOf('WATSON') > -1 || $scope.tenant.captioningServiceList.indexOf('REV') > -1)){
                                        $scope.showWatsonButton = true;
                                    }
                                }
                            }

                            console.log(asset);

                            if(asset.ccAvailable){
                                $scope.captionVar = "Closed Captions Available";
                            }

                            // Get the asset comments
                            AssetService.GetComments.query({
                                cid: collectionId,
                                aid: assetId,
                                offset: $scope.currentPage * $scope.commentsPerPage,
                                limit: $scope.commentsPerPage
                            }, function (comments) {
                                $scope.comments = $scope.mediaType === 'av' ? parseComments(comments) : comments;
                            });

                            //check if the file was checked for captioning
                            BaseFileService.GetMCBaseFile.get({id: asset.hfId}, function(result){

                                if(result.sendForCaptioning && !asset.ccAvailable){
                                    console.log("file was sent for captioning - "+result.sendForCaptioning);
                                    $scope.captionVar = "Sent for captioning.  Generating Captions...";
                                    $scope.tickedForCaptioning = true;
                                }
                            });

                            atmosphereSetup();
                        });
                    };

                    //Send for captioning
                    $scope.sendFileForCaptioning = function(assetId){
                        $scope.subtitles = "[{'language': 'English','listOrder': 1, 'enabledByDefault': true}]";
                        $scope.sentForCaptioning = true;
                        $scope.captionVar = "Sent for captioning.  Generating Captions...";
                        AssetService.GetAssetFilePath.get({aid: assetId, subtitles: $scope.subtitles});
                    };

                    $scope.getTranscript = function(assetId){
                        DownloadableMedia.getMedia({
                            aid: $scope.asset.aid,
                            cid: $scope.asset.cid,
                            type: 'transcript'
                        }, function (result) {

                            var fileUrl = result.url,
                                fileName = result.name;

                            if(fileUrl) {
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('href', fileUrl);
                                linkElement.setAttribute("download", fileName);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }

                        });
                    };

                    $scope.getChat = function(assetId){
                        DownloadableMedia.getMedia({
                            aid: $scope.asset.aid,
                            cid: $scope.asset.cid,
                            type: 'chat'
                        }, function (result) {
                            var fileUrl = result.url,
                                fileName = result.name;

                            if(fileUrl) {
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('href', fileUrl);
                                linkElement.setAttribute("download", fileName);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }
                        });
                    };

                    getAsset();

                    // This is called whenever an asset is made favorite or not favorite
                    $scope.toggleFavorite = function (collectionId, assetId) {
                        var asset = this.asset,
                            isFavorite = asset.isFavorite;
                        AssetService.toggleAssetFavorite(this.asset, assetId, collectionId)
                            .then(function(response){
                                if(response.result){
                                    asset.isFavorite = !isFavorite;
                                }
                            }).catch(function() {
                                $log.error("An error occurred when trying to make asset favorite");
                            });
                    };

                    // This is called whenever a comment needs to be added
                    $scope.addComment = function (commentText) {
                        var addComment = new AssetService.AddComment({
                            cid: collectionId,
                            aid: assetId,
                            text: commentText
                        });
                        addComment.$save(function (response) {
                            $scope.addCommentError = !response.result;
                            if (response.result) {
                                // Clear the form if submission is successful
                                $scope.addCommentForm.$setPristine();
                                $scope.commentText = "";
                                // Refresh the comments list
                                refreshComments();
                            }
                        });
                    };

                    // Logic for showing/hiding comment delete button
                    $scope.isDeletable = function () {
                        return (this.comment.author === $scope.account.login || this.comment.author === $scope.userFullName || $scope.asset.acl.indexOf("W") !== -1);
                    };

                    $scope.deleteComment = function (commentId) {
                        AssetService.DeleteComment.erase({
                            cid: collectionId,
                            aid: assetId,
                            commentId: commentId
                        }, function () {
                            refreshComments();
                        });
                    };

                    var refreshComments = function () {
                        AssetService.GetAsset.get({cid: collectionId, aid: assetId}, function (result) {
                            $scope.asset.totalComments = result.totalComments;
                        });
                        $scope.currentPage = 0;
                        AssetService.GetComments.query({
                            cid: collectionId,
                            aid: assetId,
                            offset: $scope.currentPage * $scope.commentsPerPage,
                            limit: $scope.commentsPerPage
                        }, function (comments) {
                            $scope.comments = $scope.mediaType === 'av' ? parseComments(comments) : comments;
                        });
                    };

                    $scope.loadMoreComments = function () {
                        $scope.currentPage++;
                        AssetService.GetComments.query({
                            cid: collectionId,
                            aid: assetId,
                            offset: $scope.currentPage * $scope.commentsPerPage,
                            limit: $scope.commentsPerPage
                        }, function (comments) {
                            $scope.comments = $scope.comments.concat($scope.mediaType === 'av' ? parseComments(comments) : comments);
                        });
                    };

                    /*
                     Seek to a particular position in the video/audio based on the time provided (time is a string here in hh:mm:ss or mm:ss format)
                     */
                    $scope.jumpPlaybackTo = function (time) {

                        var parts = time.split(":"),
                            seconds = 0;

                        // convert the timestamp string into seconds since the Flowplayer seek API requires seek time to be in seconds
                        if (parts.length === 3) {
                            seconds = parseInt(parts[0], 10) * 3600 + parseInt(parts[1], 10) * 60 + parseInt(parts[2], 10);
                        } else if (parts.length === 2) {
                            seconds = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
                        }

                        // if the asset is an audio/video, use Flowplayer APIs to seek to a particular point in the asset.
                        if ($scope.mediaType === 'av') {
                            var elem = document.getElementById("player");
                            var api = flowplayer(elem);
                            if (api.ready) {
                                api.seek(seconds);
                                if (api.paused) {
                                    api.play();
                                }
                            } else {
                                api.load();
                                api.on('ready', function (e, api) {
                                    api.seek(seconds);
                                });
                            }
                            $('#player').focus();
                        }
                    };

                    $scope.download = function () {
                        DownloadableMedia.getMedia({
                            aid: $scope.asset.aid,
                            cid: $scope.asset.cid,
                            type: $scope.asset.type
                        }, function (result) {

                            var fileUrl = result.url,
                                fileName = result.name;

                            if(fileUrl) {
                                var linkElement = document.createElement('a');
                                linkElement.setAttribute('href', fileUrl);
                                linkElement.setAttribute("download", fileName);
                                var clickEvent = new MouseEvent("click", {
                                    "view": window,
                                    "bubbles": true,
                                    "cancelable": false
                                });
                                linkElement.dispatchEvent(clickEvent);
                            }

                        });
                        var recordPlayback = new AssetService.RecordPlayback({cid: $scope.asset.cid, aid: $scope.asset.aid, type: 'D'});
                        recordPlayback.$save();
                    };

                    // This is used to populate the embed code modal
                    $scope.showLink = function (collectionId, assetId) {
                        var showLink = new AssetService.ShowLink({cid: collectionId, aid: assetId});
                        showLink.$save(function (response) {
                            $scope.assetStreamableLink = response.streamableLink ? response.streamableLink : 'Not Available';
                            $scope.streamLinkPublic = response.isStreamableLinkPublic;
                            $scope.assetDownloadableLink = response.downloadableLink ? response.downloadableLink : 'Not Available';
                            $scope.downLinkPublic = response.isDownloadableLinkPublic;
                            $scope.assetEmbedCode = response.embedCode ? response.embedCode : 'Not Available';
                            $scope.sharedAssetCid = collectionId;
                            $scope.sharedAssetAid = assetId;
                            getAsset();
                        });
                    };

                    // This is used to populate the embed code modal
                    $scope.createHideLinkRequest = function (collectionId, assetId) {
                        $scope.hideLinkRequest = new AssetService.HideLink({cid: collectionId, aid: assetId});
                    };

                    $scope.hideLink = function () {
                        $scope.hideLinkRequest.$save(function (response) {
                            if (response.result) {
                                getAsset();
                            }
                        });
                    };

                    $scope.sharePublicly = function (sharePublicSelected, linkType) {
                        var toggleLinkStatus = new AssetService.ToggleLinkStatus({
                            cid: $scope.sharedAssetCid,
                            aid: $scope.sharedAssetAid,
                            isPublic: sharePublicSelected,
                            linkType: linkType
                        });
                        toggleLinkStatus.$save(function (response) {
                            if (linkType === 'S') {
                                $scope.assetStreamableLink = response.link;
                                $scope.assetEmbedCode = response.embedCode;
                                $scope.streamLinkPublic = sharePublicSelected;
                            } else if (linkType === 'D') {
                                $scope.assetDownloadableLink = response.link;
                                $scope.downLinkPublic = sharePublicSelected;
                            }
                        })
                    };

                    $scope.goBack = function () {

                        if ($scope.parent.type === 'course') {
                            if ($scope.hideHeaderAndFooter) {
                                $state.go('lmsCourse', {
                                    collectionId: $scope.parent.cid,
                                    type: $scope.parent.type
                                });
                            } else {
                                $state.go('course', {
                                    collectionId: $scope.parent.cid,
                                    type: $scope.parent.type
                                });
                            }
                        } else if ($scope.parent.type === 'channel') {
                            $state.go('channel', {
                                collectionId: $scope.parent.cid,
                                type: $scope.parent.type
                            });
                        } else if ($scope.parent.type === 'protected') {
                            $state.go('protected', {
                                collectionId: $scope.parent.cid,
                                type: $scope.parent.type
                            });
                        } else if ($scope.parent.type === 'reserves') {
                            $state.go('protected', {
                                collectionId: $scope.parent.cid,
                                type: $scope.parent.type
                            });
                        }
                    };

                    $scope.checkForEnterKey = function (event, action) {
                        if (event.keyCode === 13) {
                            switch(action){
                                case "goBack":
                                    $scope.goBack();
                                    break;
                            }
                        }
                    };
                }
            });
        });
    });
